export default {
  fields: {
    id: 'CatalogID',
    image: 'ThumbnailFile',
    title: 'Name',
    url: 'ProductLink',
  },
  getItemId: () => window.document.querySelector('input#catalogid[name="item_id"]').value,
};
